
/* ===== index.html inline @line 3202 ===== */

  if (window.innerWidth > 992) {
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/lenis@1.1.13/dist/lenis.min.js';
    script.onload = () => {
      // После загрузки Lenis
      const lenis = new Lenis({
        lerp: 0.08, // Плавность: меньше значение — более плавно
        smoothWheel: true, // Включить плавность колеса мыши
        smoothTouch: false, // Можно включить, если нужен плавный тач-скролл
        infinite: false // Без бесконечного скролла
      });
      window.beckerLenis = lenis;

      // Цикл анимации
      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }

      requestAnimationFrame(raf);
    };
    document.head.appendChild(script);
  }


/* ===== index.html inline @line 3230 ===== */

  document.addEventListener("DOMContentLoaded", function() {
    // Функция для добавления неразрывных пробелов
    function replacePrepositions(text) {
      // Список предлогов, которые нужно обработать
      const prepositions = ["в", "без", "до", "из", "к", "по", "о", "от", "перед", "при", "через", "с", "у", "за", "над", "об", "под", "про", "и", "а", "но", "да", "или", "либо", "то", "ни", "не", "же", "как"];

      // Регулярное выражение для поиска предлогов
      const regex = new RegExp(`\\s(${prepositions.join("|")})\\s`, "gi");

      // Заменяем пробелы на неразрывные пробелы
      return text.replace(regex, " $1&nbsp;");
    }

    // Функция для обработки текста в элементах с определенным классом
    function processElements() {
      // Выбираем все элементы с классом "no-break-prepositions"
      const elements = document.querySelectorAll(".no-break-prepositions");

      elements.forEach(function(element) {
        // Обрабатываем текст в каждом элементе
        element.innerHTML = replacePrepositions(element.innerHTML);
      });
    }

    // Запускаем обработку текста
    processElements();
  });
  